const window = require('window');
const Backbone = require('backbone');
const externalScriptLoader = require('externalScriptLoader');
const ReviewsView = Backbone.View.extend({
	campaignIds: {
		'product:display': 'BV_REVIEW_DISPLAY',
		'ecrm:order': 'Account_Overview_Submission_Form'
	},
	events: {
		'click .js-review-trigger': 'writeReview'
	},
	isReviewsLoaded: false,
	initialize: function(options = {}) {
		this.options = Object.assign(
			{
				isLoaded: false
			},
			options
		);

		if (!this.options.url) {
			window.clientErrorHandler(new Error('no URL specified for loading bazaarvoice widget'));
			return;
		}

		this._registerCallback();
		this._loadWidget(() => {
			if (this.options.callback && typeof this.options.callback === 'function') {
				this.options.callback();
			}
			if (this.callOnLoad) {
				this.callOnLoad();
				this.callOnLoad = null;
			}
		});
	},
	initWidget: function(productId) {
		window.$BV.configure('global', { productId: `cp-${productId}` });
		window.$BV.isConfigureGlobalOn = true;
	},
	writeReview: function(e = null) {
		if (window.$BV) {
			this._writeReview(e);
		} else {
			this.callOnLoad = () => {
				this._writeReview(e);
			};
		}
	},
	_writeReview: function(e = null) {
		const params = {};
		if (e && !this.options.productId) {
			if ($(e.target).data('productCompositeId')) {
				this.initWidget($(e.target).data('productCompositeId'));
			} else {
				this.initWidget($(e.currentTarget).data('productCompositeId'));
			}
		} else {
			this.initWidget(this.options.productId);
		}
		if (this.campaignIds[window.dataLayer.page]) {
			params.campaignId = this.campaignIds[window.dataLayer.page];
		}
		window.$BV.ui('rr', 'submit_review', params);
	},
	_registerCallback() {
		window.bvCallback = (BV) => {
			BV.reviews.on('show', () => {
				if (this.options.onShowReview && typeof this.options.onShowReview === 'function') {
					this.options.onShowReview();
				}
			});
		};
	},
	_loadWidget(callback = null) {
		if (!window.$BV) {
			externalScriptLoader(`${this.options.url}`.replace('%s', this.options.zone), () => {
				this.options.isLoaded = true;
				if (callback) {
					callback();
				}
			});
		} else {
			this.options.isLoaded = true;
			if (callback) {
				callback();
			}
		}
	}
});

module.exports = ReviewsView;
